import ZahlungUndVersand from 'src/pages/ZahlungUndVersand/ZahlungUndVersand'
import { getSitePageBuilderStaticProps } from 'src/pageBuilder/sitePageBuilder'

export default ZahlungUndVersand

export const getStaticProps = getSitePageBuilderStaticProps
